import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import useLocalStorage from "../useLocalStorage";
import { logout } from "../services/api";

const Header = (props) => {
  const { ls } = useLocalStorage();
  const { userName, tenant } = ls;

  const handleLogout = async () => {
    await logout();
    props.history.push("/Login");
  };

  return (
    <div className="bg-gray-100 font-sans w-full m-0">
      <div className="bg-white shadow">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <Link to="/">
              <img src={logo} className="App-logo" alt="logo" />
            </Link>

            <div className="flex items-center">
              <span className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>

                <p className="text-gray-800 text-sm font-semibold hover:text-blue-600 mx-2">
                  {userName} @{tenant}
                </p>
              </span>
              <button
                onClick={handleLogout}
                className="text-gray-800 text-sm font-semibold border px-4 py-2 rounded-lg hover:text-blue-600 hover:border-blue-600"
              >
                Logout
              </button>
            </div>
          </div>

          {/* <div className="block sm:hidden bg-white py-2">
            <div className="flex flex-col">
              <div className="flex justify-between items-center pt-2">
                <span className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>

                  <p className="text-gray-800 text-sm font-semibold hover:text-blue-600 mx-2">
                    {userName} @{tenant}
                  </p>
                </span>

                <Link
                  to="/Login"
                  className="text-gray-800 text-sm font-semibold border px-4 py-1 rounded-lg hover:text-blue-600 hover:border-blue-600"
                >
                  Logout
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Header);
